import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class ProductGuard implements CanActivate {
  constructor(private apiService: ApiService, private title: Title, private route: ActivatedRoute,
    private router: Router, private location: Location) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    var storeDetails = JSON.parse(sessionStorage.getItem('store'));
    var featureTags = JSON.parse(sessionStorage.getItem("featureTags"));

    if (state.url === '/categories') {
      this.title.setTitle('All Categories');
      return true;
    } else if (state.url.includes('vendors') || isNaN(parseInt(next.paramMap.get('subCategory'))) === false) {
      return this.apiService.getVendor().pipe(map(data => {
        if (data['response']['status'] === 1) {
          const index = data['response']['data']['vendor_list'].findIndex(val => val['id'] === parseInt(next.paramMap.get('subCategory')))
          if (index < 0) {
            this.title.setTitle('Not Found ');
            return true;
          }
          var dynamicTitle = index > -1 ? data['response']['data']['vendor_list'][index]['vendor_name'].replace('&amp;', '&') : next.paramMap.get('parentCategory');
          var finalTitle = !!storeDetails && !!storeDetails['siteTitle'] ? dynamicTitle + ' - ' + storeDetails['siteTitle'] : dynamicTitle;

          this.title.setTitle(finalTitle);
          return true;
        } else {
          return true;
        }
      }))
    } else if (state.url === '/shop') {
      this.title.setTitle('Customer Dashboard');
      return true;
    } else {
      return this.apiService.categories().pipe(map(data => {
        if (data['response']['status'] === 1) {
          const parentCategoryIndex = data['response']['data']['cat_list'].findIndex(val => val['category_url'] === next.paramMap.get('parentCategory'));
          const subCategoryIndex = !!next.paramMap.get('subCategory') && parentCategoryIndex > -1 ? data['response']['data']['cat_list'][parentCategoryIndex]['sub_list'].findIndex(val => val['category_url'] === next.paramMap.get('subCategory')) : null;

          if ((!!next.paramMap.get('parentCategory') && parentCategoryIndex < 0) && (!!next.paramMap.get('subCategory') && subCategoryIndex < 0)) {
            this.title.setTitle('Not Found ');
            return true;
          }
          if (!!featureTags && featureTags['sf_seo']== false) {
            var subCategory = next.paramMap.get('subCategory');
            var parentCategory = next.paramMap.get('parentCategory');
            
            var dynamicTitle = !!subCategory
              ? parentCategoryIndex > -1 && subCategoryIndex > -1
                ? `${data['response']['data']['cat_list'][parentCategoryIndex]['category_name'].replace('&amp;', '&')} - ${data['response']['data']['cat_list'][parentCategoryIndex]['sub_list'][subCategoryIndex]['category_name'].replace('&amp;', '&')} `
                : subCategory ? subCategory.toUpperCase().replace('&amp;', '&') : ''
              : parentCategoryIndex > -1
                ? `${data['response']['data']['cat_list'][parentCategoryIndex]['category_name'].replace('&amp;', '&')}`
                : parentCategory ? parentCategory.toUpperCase().replace('&amp;', '&') : '';
            
            var finalTitle = !!storeDetails && !!storeDetails['siteTitle'] 
              ? dynamicTitle + ' - ' + storeDetails['siteTitle'] 
              : dynamicTitle;
            
            this.title.setTitle(finalTitle);
          }
          return true;
        } else {
          return true;
        }
      }));
    }



  }
}
